import { Group, useMantineTheme } from '@mantine/core';
import { IconWorldPlus } from '@tabler/icons-react';
import OrganizationList from 'components/OrganizationList';
import { EvidenceFieldRow } from 'components/tables/data/evidence-field/types';
import P2Medium from 'components/typography/P2Medium';

/**
 * Column for the evidence field structure.
 */
export default function StructureColumn({
  data: { allOrganizations, organizations = [] },
}: {
  data: EvidenceFieldRow;
}) {
  const theme = useMantineTheme();

  if (allOrganizations) {
    return (
      <Group spacing={8} align="center">
        <IconWorldPlus stroke={2} color={theme.colors.red[8]} size={20} />
        <P2Medium color="gray.8" mt={4}>
          Všetky organizácie
        </P2Medium>
      </Group>
    );
  }

  return <OrganizationList organizations={organizations} limit={2} />;
}
